import React from 'react'

import './AddressButton.css'

const AddressButton = props => {
  const { label, onClick } = props
  return (
    <div className="cookunity__address_button" onClick={onClick}>
      <span>
        <i className="fas fa-plus" /> {label}
      </span>
    </div>
  )
}

export default AddressButton



// WEBPACK FOOTER //
// ./src/components/AddressButton/AddressButton.jsx